import React from "react";

const BankTransfersList = React.lazy(() => import("src/pages/bank_transfers/BankTransfersList"));

const routes = [
    { path: "/dashboard/bank-transfer-list", name: "Bank Transfers", element: BankTransfersList },
];

export default routes;